<p-dialog 
    [(visible)]="visible"
    (visibleChange)="onClose()"
    [modal]="true"
    [style]="{ width: '500px', maxWidth: '90vw' }"
    [draggable]="false"
    [resizable]="false"
    [closable]="true"
    [closeOnEscape]="true"
    [showHeader]="false"
    (onShow)="onDialogShow()"
    [styleClass]="dialogStyleClass">
    
    <div class="confirmation-popup-content" [attr.data-variant]="variant">
        @if (imageUrl) {
          <div class="popup-image-wrapper">
            <img [src]="imageUrl" alt="Preview" class="popup-image" />
          </div>
        }
        @if (icon) {
          <div class="popup-icon-wrapper">
            <i class="popup-icon" [ngClass]="icon" aria-hidden="true"></i>
          </div>
        }

        <div class="popup-message" [class.popup-message--multiline]="isMultiline">
            @if (isMultiline) {
              <div class="popup-message-title">{{ messageTitle }}</div>
              <div class="popup-message-body">{{ messageBody }}</div>
            } @else {
              {{ message }}
            }
        </div>
        
        <div class="popup-footer" [class.popup-footer--single]="showOnlyConfirm">
            @if (!showOnlyConfirm) {
              @if (destructiveConfirm) {
                <button class="btn btn-danger" type="button" (click)="onOkClick()">
                  {{ confirmLabel }}
                </button>
                <button #safeButton class="btn btn-primary" type="button" (click)="onCancelClick()">
                  {{ cancelLabel }}
                </button>
              } @else {
                <button class="btn btn-secondary" type="button" (click)="onCancelClick()">
                  {{ cancelLabel }}
                </button>
                @if (denyLabel) {
                  <button class="btn btn-secondary" type="button" (click)="onDenyClick()">
                    {{ denyLabel }}
                  </button>
                }
                <button class="btn btn-primary" type="button" (click)="onOkClick()">
                  {{ confirmLabel }}
                </button>
              }
            } @else {
              <button class="btn btn-primary" type="button" (click)="onOkOrClose()">
                {{ confirmLabel }}
              </button>
            }
        </div>
    </div>
</p-dialog>
